import { RevealLines, FadeUp } from "@/components/site/Reveal";
import { CONTACT } from "@/data/site";

const SECTIONS = [
  {
    title: "Éditeur du site",
    body: [
      "Le présent site est édité par Equinoxe Studio, filiale du Groupe Equinoxe.",
      `Siège : ${CONTACT.city} (${CONTACT.postal}), France.`,
      `Téléphone : ${CONTACT.phone} — ${CONTACT.hours}. WhatsApp 24h/24, 7j/7 au même numéro.`,
    ],
  },
  {
    title: "Responsable de la publication",
    body: ["La direction d'Equinoxe Studio. Pour toute demande, utilisez le formulaire de la page Contact."],
  },
  {
    title: "Conception & Hébergement",
    body: ["Le site est propulsé par Equinoxe Studio."],
  },
  {
    title: "Propriété intellectuelle",
    body: [
      "L'ensemble des éléments présents sur ce site (textes, visuels, logo, identité graphique, code) est la propriété d'Equinoxe Studio ou de ses partenaires, sauf mention contraire.",
      "Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation écrite préalable, est interdite et constitue une contrefaçon.",
    ],
  },
  {
    title: "Données personnelles",
    body: [
      "Les informations transmises via le formulaire de contact (nom, email, téléphone, message) sont utilisées uniquement pour traiter votre demande et ne sont ni vendues ni cédées à des tiers.",
      "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour l'exercer, contactez-nous via la page Contact.",
    ],
  },
  {
    title: "Cookies",
    body: [
      "Ce site peut utiliser des cookies de mesure d'audience afin d'améliorer votre expérience de navigation. Vous pouvez configurer votre navigateur pour les refuser.",
    ],
  },
];

export default function MentionsLegales() {
  return (
    <div data-testid="mentions-legales-page">
      <section className="mx-auto max-w-[1000px] px-6 lg:px-12 pt-40 lg:pt-52 pb-16">
        <p className="mb-8 flex items-center gap-3 text-sm tracking-[0.25em] uppercase text-muted-foreground">
          <span className="h-px w-10 bg-violet" /> Informations légales
        </p>
        <h1 className="font-display font-extrabold tracking-tighter leading-[0.9] text-6xl sm:text-7xl">
          <RevealLines lines={["Mentions", "légales."]} />
        </h1>
      </section>

      <section className="mx-auto max-w-[1000px] px-6 lg:px-12 pb-28">
        <div className="divide-y divide-black/10 border-t border-black/10">
          {SECTIONS.map((s, i) => (
            <FadeUp key={s.title} delay={(i % 3) * 0.05}>
              <div className="grid md:grid-cols-12 gap-4 md:gap-8 py-10">
                <div className="md:col-span-4">
                  <span className="font-editorial text-lg text-violet mr-2">{String(i + 1).padStart(2, "0")}</span>
                  <h2 className="mt-2 font-display font-bold text-2xl tracking-tight">{s.title}</h2>
                </div>
                <div className="md:col-span-8 space-y-4">
                  {s.body.map((p, j) => (
                    <p key={j} className="text-muted-foreground leading-relaxed">
                      {p}
                    </p>
                  ))}
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </section>
    </div>
  );
}
